var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"fw-v2",attrs:{"role":"main"}},[_c('portal',{attrs:{"to":"ariane"}},[_c('div',{staticClass:"tbv2-page-title"},[_vm._v(_vm._s(_vm.$t('wizard.newForm')))])]),_c('custom-wizard',{attrs:{"form-id":_vm.formId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }